import React from 'react';
import {
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  TableContainer,
  Heading,
  Button,
  Box,
  Badge,
  Avatar,
  Flex,
  Text,
  Spinner,
} from '@chakra-ui/react';
import { Link, useNavigate } from 'react-router-dom';
import { FiPlus, FiArrowRight } from 'react-icons/fi';
import xhr from 'xhr';

export default function Instituciones() {
  const [schools, setSchools] = React.useState([]);
  const [loading, setLoading] = React.useState(true);
  const navigate = useNavigate();

  React.useEffect(() => {
    const fetchSchools = async () => {
      try {
        const res = await xhr(`/schools?populate=*&sort[0]=name:asc`);
        const schoolsData = res.data.data;

        // Fetch student counts and school-program counts for each school
        const enriched = await Promise.all(
          schoolsData.map(async (school) => {
            const [studentsRes, programsRes] = await Promise.all([
              xhr(`/students?filters[schoolFrom][id][$eq]=${school.id}&pagination[pageSize]=1&pagination[withCount]=true`),
              xhr(`/school-programs?filters[school][id][$eq]=${school.id}&filters[active][$eq]=true&pagination[pageSize]=1&pagination[withCount]=true`),
            ]);
            return {
              ...school,
              studentCount: studentsRes.data.meta?.pagination?.total || 0,
              programCount: programsRes.data.meta?.pagination?.total || 0,
            };
          })
        );

        setSchools(enriched);
      } catch (error) {
        console.error('Error fetching schools:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchSchools();
  }, []);

  if (loading) {
    return (
      <Box p={8} textAlign="center">
        <Spinner size="lg" />
      </Box>
    );
  }

  return (
    <Box p={4}>
      <Flex justifyContent="space-between" alignItems="center" mb={6}>
        <Heading size="md">Instituciones</Heading>
        <Button
          leftIcon={<FiPlus />}
          colorScheme="purple"
          onClick={() => navigate('/plataforma/administrador/instituciones/nueva')}
        >
          Nueva Institución
        </Button>
      </Flex>

      <TableContainer bg="white" borderRadius="lg" boxShadow="sm">
        <Table variant="simple">
          <Thead>
            <Tr>
              <Th>Institución</Th>
              <Th>Subdominio</Th>
              <Th>Contacto</Th>
              <Th isNumeric>Estudiantes</Th>
              <Th isNumeric>Programas</Th>
              <Th>Estado</Th>
              <Th></Th>
            </Tr>
          </Thead>
          <Tbody>
            {schools.map((school) => (
              <Tr key={school.id}>
                <Td>
                  <Flex alignItems="center" gap={3}>
                    <Avatar
                      size="sm"
                      name={school.attributes?.name || school.name}
                      src={school.attributes?.logo_url || school.logo_url}
                    />
                    <Text fontWeight="medium">
                      {school.attributes?.name || school.name}
                    </Text>
                  </Flex>
                </Td>
                <Td>
                  <Text fontSize="sm" color="gray.600">
                    {school.attributes?.domain || school.domain || '—'}
                  </Text>
                </Td>
                <Td>
                  <Text fontSize="sm">
                    {school.attributes?.contact_name || school.contact_name || '—'}
                  </Text>
                  <Text fontSize="xs" color="gray.500">
                    {school.attributes?.contact_email || school.contact_email || ''}
                  </Text>
                </Td>
                <Td isNumeric>{school.studentCount}</Td>
                <Td isNumeric>{school.programCount}</Td>
                <Td>
                  <Badge colorScheme={(school.attributes?.active ?? school.active) !== false ? 'green' : 'red'}>
                    {(school.attributes?.active ?? school.active) !== false ? 'Activo' : 'Inactivo'}
                  </Badge>
                </Td>
                <Td>
                  <Button
                    size="sm"
                    colorScheme="purple"
                    variant="ghost"
                    rightIcon={<FiArrowRight />}
                    onClick={() => navigate(`/plataforma/administrador/instituciones/${school.id}`)}
                  >
                    Ver
                  </Button>
                </Td>
              </Tr>
            ))}
            {schools.length === 0 && (
              <Tr>
                <Td colSpan={7} textAlign="center" py={8} color="gray.500">
                  No hay instituciones registradas
                </Td>
              </Tr>
            )}
          </Tbody>
        </Table>
      </TableContainer>
    </Box>
  );
}
